import Header from "../../../component/Header";
import CnSidebar from "../../China/CnSidebar";
import React, { useEffect, useState } from "react";
import axios from "axios";
import Sidebar from "../../../component/Sidebar";
import { Oval } from "react-loader-spinner";
import RemainingItemsByDelivery from "./RemainingItemsByDelivery";

const apiUrl = process.env.REACT_APP_API_URL;

function ShippedTo() {
  const [deliveryPeople, setDeliveryPeople] = useState([]);
  const [selectedDeliveryPerson, setSelectedDeliveryPerson] = useState("");
  const [orderNumber, setOrderNumber] = useState("");
  const [shipments, setShipments] = useState([]);
  const [filteredShipments, setFilteredShipments] = useState([]);
  const [filterYear, setFilterYear] = useState("");
  const [statusMessage, setStatusMessage] = useState("");
  const [statusType, setStatusType] = useState(""); // 'success' | 'error' | 'warning'
  const [isBulkMode, setIsBulkMode] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [startOrder, setStartOrder] = useState("");
  const [endOrder, setEndOrder] = useState("");
  const [role, setRole] = useState(null);

  useEffect(() => {
    const storedRole = localStorage.getItem("role");
    setRole(storedRole);
  }, []);

  const currentMonthShortForm = () => {
    const monthIndex = new Date().getMonth();
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    return monthNames[monthIndex];
  };
  const [selectedMonth, setSelectedMonth] = useState(currentMonthShortForm()); // Initialize to current month
  const [filterMonth, setFilterMonth] = useState(currentMonthShortForm());

  useEffect(() => {
    // Replace this with actual API call if need
    setDeliveryPeople(["Fu", "Su", "Kidi", "Glow", "Ephrem"]);
  }, []);

  const fetchShipments = async () => {
    try {
      const res = await axios.get(`${apiUrl}/items`);
      setShipments(res.data);
    } catch (err) {
      console.error("Failed to fetch shipments:", err);
    }
  };

  useEffect(() => {
    let filtered = [...shipments];

    if (selectedDeliveryPerson) {
      filtered = filtered.filter(
        (item) => item.deliveryPerson === selectedDeliveryPerson,
      );
    }

    if (filterMonth) {
      filtered = filtered.filter((item) =>
        item.OrderNumber?.startsWith(filterMonth),
      );
    }

    if (filterYear) {
      filtered = filtered.filter((item) => {
        const date = new Date(item.TimeStamp);
        return date.getFullYear().toString() === filterYear;
      });
    }
    setFilteredShipments(filtered);
  }, [selectedDeliveryPerson, shipments, filterMonth, filterYear]);

  const handleAddShipment = async () => {
    setIsLoading(true);
    if (
      !selectedDeliveryPerson ||
      !selectedMonth ||
      (isBulkMode ? !startOrder || !endOrder : !orderNumber)
    ) {
      setStatusType("warning");
      setStatusMessage("⚠️ All fields are required.");
      return;
    }

    const orderNumbers = [];
    const yearShort = new Date().getFullYear().toString().slice(-2); // "25" for 2025

    if (isBulkMode) {
      const start = parseInt(startOrder, 10);
      const end = parseInt(endOrder, 10);

      if (isNaN(start) || isNaN(end) || start > end) {
        setStatusType("error");
        setStatusMessage("❌ Invalid start/end range.");
        return;
      }

      for (let i = start; i <= end; i++) {
        for (let i = start; i <= end; i++) {
          orderNumbers.push(
            `${selectedMonth}${yearShort} ${String(i).padStart(3, "0")}`,
          );
        }
      }
    } else {
      orderNumbers.push(`${selectedMonth}${yearShort} ${orderNumber}`);
    }

    let successCount = 0;

    for (const number of orderNumbers) {
      try {
        const res = await axios.get(
          `${apiUrl}/items/${encodeURIComponent(number)}`,
        );
        if (Array.isArray(res.data) && res.data.length > 0) {
          await axios.put(`${apiUrl}/shipments/${encodeURIComponent(number)}`, {
            deliveryPerson: selectedDeliveryPerson,
          });
          successCount++;
        }
      } catch (error) {
        console.error(`Failed to update order ${number}:`, error);
      }
    }

    fetchShipments();

    if (successCount > 0) {
      setStatusType("success");
      setStatusMessage(`✅ ${successCount} order(s) updated.`);
    } else {
      setStatusType("error");
      setStatusMessage(`❌ No orders were updated.`);
    }
    setIsLoading(false);
    setOrderNumber("");
    setStartOrder("");
    setEndOrder("");
  };

  const handleMonthChange = (event) => {
    const month = event.target.value;
    setSelectedMonth(month);
  };

  useEffect(() => {
    fetchShipments();
  }, []);

  useEffect(() => {
    if (statusMessage) {
      const timer = setTimeout(() => {
        setStatusMessage("");
        setStatusType("");
      }, 5000); // Clear after 5 seconds

      return () => clearTimeout(timer);
    }
  }, [statusMessage]);
  
  return (
    <div className="min-h-screen mb-20">
      <Header />
      {role === "Admin" ? <Sidebar /> : null}
      {role !== "Admin" ? <CnSidebar /> : null}
      <div className="p-6 max-w-4xl mx-auto">
        <RemainingItemsByDelivery
          shipments={shipments}
          deliveryPeople={deliveryPeople}
        />
      </div>
      <div className="p-6 pt-6 max-w-4xl mx-auto">
        <h1 className="text-2xl font-bold mb-4">📦 Shipment Tracking</h1>
        {statusMessage && (
          <p
            className={`mb-4 p-2 rounded text-center ${
              statusType === "success"
                ? "bg-green-100 text-green-700"
                : statusType === "error"
                  ? "bg-red-100 text-red-700"
                  : "bg-yellow-100 text-yellow-700"
            }`}
          >
            {statusMessage}
          </p>
        )}

        <div className="flex flex-col sm:flex-row gap-4 mb-4">
          <select
            value={selectedDeliveryPerson}
            onChange={(e) => setSelectedDeliveryPerson(e.target.value)}
            className="p-2 border rounded w-full"
          >
            <option value="">Select Delivery Person</option>
            {deliveryPeople.map((person, idx) => (
              <option key={idx} value={person}>
                {person}
              </option>
            ))}
          </select>

          <select
            id="month-select"
            onChange={handleMonthChange}
            value={selectedMonth}
            className="p-2 border rounded w-full"
          >
            <option value="">Select Month:</option>
            <option value="Jan">January</option>
            <option value="Feb">February</option>
            <option value="Mar">March</option>
            <option value="Apr">April</option>
            <option value="May">May</option>
            <option value="Jun">June</option>
            <option value="Jul">July</option>
            <option value="Aug">August</option>
            <option value="Sep">September</option>
            <option value="Oct">October</option>
            <option value="Nov">November</option>
            <option value="Dec">December</option>
          </select>

          <div className="flex flex-col w-full">
            <label className="flex items-center mb-1">
              <input
                type="checkbox"
                checked={isBulkMode}
                onChange={(e) => setIsBulkMode(e.target.checked)}
                className="mr-2"
              />
              Bulk Mode
            </label>

            {isBulkMode ? (
              <div className="flex gap-2">
                <input
                  type="text"
                  placeholder="Start (e.g., 001)"
                  value={startOrder}
                  onChange={(e) => setStartOrder(e.target.value)}
                  className="p-2 border rounded w-full"
                />
                <input
                  type="text"
                  placeholder="End (e.g., 030)"
                  value={endOrder}
                  onChange={(e) => setEndOrder(e.target.value)}
                  className="p-2 border rounded w-full"
                />
              </div>
            ) : (
              <input
                type="text"
                placeholder="Order Number"
                value={orderNumber}
                onChange={(e) => setOrderNumber(e.target.value)}
                className="p-2 border rounded w-full"
              />
            )}
          </div>

          {isLoading ? (
            <button
              onClick={handleAddShipment}
              className="bg-blue-500 text-white px-4 py-2 rounded"
            >
              <Oval
                height={20}
                width={20}
                color="#fff"
                wrapperStyle={{}}
                wrapperClass=""
                visible={true}
                ariaLabel="oval-loading"
                secondaryColor="#4fa94d"
                strokeWidth={2}
                strokeWidthSecondary={2}
              />
            </button>
          ) : (
            <button
              onClick={handleAddShipment}
              className="bg-blue-500 text-white px-4 py-2 rounded"
            >
              Add
            </button>
          )}
        </div>

        <div className="flex flex-col sm:flex-row gap-4 mb-4">
          <label className="mr-2 font-bold">Filter by Delivery Person:</label>
          <select
            value={selectedDeliveryPerson}
            onChange={(e) => setSelectedDeliveryPerson(e.target.value)}
            className="p-2 border rounded"
          >
            <option value="">All</option>
            {deliveryPeople.map((person, idx) => (
              <option key={idx} value={person}>
                {person}
              </option>
            ))}
          </select>
          <div>
            <label className="mr-2 font-bold">Filter by Month:</label>
            <select
              value={filterMonth}
              onChange={(e) => setFilterMonth(e.target.value)}
              className="p-2 border rounded"
            >
              <option value="">All</option>
              {[
                "Jan",
                "Feb",
                "Mar",
                "Apr",
                "May",
                "Jun",
                "Jul",
                "Aug",
                "Sep",
                "Oct",
                "Nov",
                "Dec",
              ].map((month) => (
                <option key={month} value={month}>
                  {month}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="mr-2 font-bold">Filter by Year:</label>
            <select
              value={filterYear}
              onChange={(e) => setFilterYear(e.target.value)}
              className="p-2 border rounded"
            >
              <option value="">All</option>
              {["2023", "2024", "2025", "2026"].map((year) => (
                <option key={year} value={year}>
                  {year}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="w-full border-collapse table-auto mt-4 max-h-screen overflow-y-auto">
          <table className="w-full border-collapse table-auto mt-4">
            <thead>
              <tr>
                <th className="border px-4 py-2">Delivery Person</th>
                <th className="border px-4 py-2">Order Number</th>
                <th className="border px-4 py-2">OurStat</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colSpan="2" className="border px-4 py-2 text-center">
                  {filteredShipments.length === 0
                    ? "No shipments found."
                    : `Total Shipments of ${selectedDeliveryPerson}: ${filteredShipments.length}`}
                </td>
              </tr>
              {filteredShipments.map((shipment, idx) => (
                <tr key={idx} className="bg-white border">
                  <td className="border px-4 py-2">
                    {shipment.deliveryPerson}
                  </td>
                  <td className="border px-4 py-2">{shipment.OrderNumber}</td>
                  <td className="border px-4 py-2">{shipment.ourStat}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default ShippedTo;
